var React = require('react');

function LinkLinkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon / Linkedin"},React.createElement("path",{"id":"Vector","d":"M6.34926 4.25821C6.34904 4.69329 6.176 5.11046 5.8682 5.41795C5.5604 5.72544 5.14306 5.89806 4.70799 5.89784C4.27291 5.89763 3.85575 5.72458 3.54826 5.41679C3.24077 5.10899 3.06814 4.69165 3.06836 4.25657C3.06858 3.8215 3.24162 3.40433 3.54942 3.09684C3.85721 2.78935 4.27455 2.61673 4.70963 2.61694C5.1447 2.61716 5.56187 2.7902 5.86936 3.098C6.17685 3.4058 6.34948 3.82314 6.34926 4.25821ZM6.39847 7.1126H3.11757V17.3818H6.39847V7.1126ZM11.5823 7.1126H8.3178V17.3818H11.5495V11.9929C11.5495 8.99091 15.462 8.71203 15.462 11.9929V17.3818H18.7018V10.8774C18.7018 5.81664 12.9111 6.00529 11.5495 8.49057L11.5823 7.1126Z","fill":"#16233C"})));
}

LinkLinkedin.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = LinkLinkedin;

LinkLinkedin.default = LinkLinkedin;
